module.exports = __webpack_public_path__ + "img/data1_en.83d9697b.jpg";